<template>
  <div class="new-item">
    <div class="header-step">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'fileList' }">{{ $t('projectDetailsV2.itemManage') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('newProjectV2.newProject') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="upload-file" v-show="fileList.length === 0">
      <el-upload drag action multiple class="upload-before" :limit="10" :accept="acceptStr" :file-list="fileList"
        :show-file-list="false" :on-exceed="handleExceed" :on-change="uploadChange" :before-upload="beforeUploadFile"
        :http-request="uploadSectionFile">
        <div class="el-upload__text" v-html="$t('newProjectV2.clickUpload')"></div>
        <div class="txt">
          {{ $t('newProjectV2.suppFormat') }}：{{ $supportFileSuffixes().tip }}</div>
      </el-upload>
    </div>
    <div class="upload-file-box" v-show="fileList.length >= 1">
      <div class="file-table">
        <div class="file-item" v-for="(item, index) in fileList" :key="item.uid">
          <div class="file-logo">
            <div class="logo-img" :class="item.name.split('.').pop()"></div>
          </div>
          <div class="file-name">
            <el-tooltip class="item" effect="dark" :content="`${item.name}`" placement="top-start"
              :disabled="isShowTooltip">
              <div class="name-txt" @mouseover="onMouseOver(item.uid)">
                <span :ref="`str${item.uid}`">{{ item.name }}</span>
              </div>
            </el-tooltip>
            <el-progress  :stroke-width="2" :status="item.exception" style="top: -20px;"
                :percentage="isNaN(item.percentage) ? 100 : item.percentage"></el-progress>
          </div>
          <div class="del-file">
            <el-tooltip class="item" effect="dark" :content="$t('newProjectV2.del')" placement="top">
              <i @click.stop="handleDelete(index)"></i>
            </el-tooltip>
          </div>
        </div>
        <!-- <el-table border :header-cell-style="{
          color: '#566087',
          background: '#F3F7FE',
        }" :data="fileList" height="100%">
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center">
            <template slot-scope="{ $index }">
              {{ $index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('newProjectV2.docName')" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="percentage" :label="$t('newProjectV2.progress')" align="center">
            <template slot-scope="{ row }">
              <el-progress :stroke-width="8" :status="row.exception"
                :percentage="isNaN(row.percentage) ? 100 : row.percentage"></el-progress>
            </template>
          </el-table-column>
          <el-table-column :label="$t('newProjectV2.action')" align="center" class-name="delete">
            <template slot-scope="{ $index }">
              <el-tooltip class="item" effect="dark" :content="$t('newProjectV2.del')" placement="top">
                <i @click.stop="handleDelete($index)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table> -->
      </div>
      <div class="upload">
        <el-upload drag action multiple class="upload-after" :limit="$supportFileSuffixes().limit" :accept="acceptStr" :file-list="fileList"
          :show-file-list="false" :on-exceed="handleExceed" :on-change="uploadChange" :before-upload="beforeUploadFile"
          :http-request="uploadSectionFile">
          <div class="el-upload__text" v-html="$t('newProjectV2.clickUpload')"></div>
          <div class="txt">{{ $t('newProjectV2.suppFormat') }}：{{ $supportFileSuffixes().tip }}</div>
        </el-upload>
      </div>
    </div>
    <div class="upload-tips">
      <div class="upload-tips-left">单个文件<span>{{$supportFileSuffixes().maxSize}}MB</span>以下，最多<span>{{ $supportFileSuffixes().limit }}</span>个文件</div>
      <div class="upload-tips-right" v-html="$t('newProjectV2.uploadFileNum', [fileList.length])"></div>
      <!-- 已上传<span>{{fileList.length}}</span>个文件 -->
    </div>
    <div class="project-form">
      <el-form :model="form" ref="ruleForm" :rules="rules" label-position="top">
        <div class="row">
          <!-- 项目名称 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.projectName')" prop="name">
              <el-input v-model="form.name" @blur="form.name = $event.target.value.trim()"
                :placeholder="$t('newProjectV2.projectNameTip')">
              </el-input>
            </el-form-item>
          </div>
          <!-- 源语言 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.sourceLang')" prop="sourceLang">
              <el-select v-model="form.sourceLang" @change="sourceLangChange"
                :placeholder="$t('newProjectV2.sourceLangTip')">
                <el-option v-for="(item, index) in sourceLangList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.sourceLangName : $langCase[item.sourceLang]"
                  :value="item.sourceLang">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 目标语言 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.targetLang')" prop="targetLang">
              <el-select v-model="form.targetLang" :placeholder="$t('newProjectV2.targetLangTip')"
                :no-data-text="$t('newProjectV2.firstSelSourceLangTip')">
                <!-- <el-option v-if="targetLangList.length === 0" :disabled="true" :label="$t('newProjectV2.firstSelSourceLangTip')" value="0"></el-option> -->
                <el-option v-for="(item, index) in targetLangList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.targetLangName : $langCase[item.targetLang]"
                  :value="item.targetLang"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <!-- 领域 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.domain')" prop="domainCode">
              <!-- :disabled="form.sourceLang === ''"  :no-data-text="$t('newProjectV2.firstSelSourceLangTip')"  :filterable="CUSTOM_DOMAIN"
                         :allow-create="CUSTOM_DOMAIN" :default-first-option="CUSTOM_DOMAIN"-->
              <el-select ref="domainCodeSelect" v-model="form.domainCode" popper-class="add-domain-select-dropdown"
                :placeholder="$t('newProjectV2.domainTip')" @change="changedomainCode">
                <el-option value="add_domain" v-if="CUSTOM_DOMAIN"><span>+{{ $t('project.create') }}</span></el-option>
                <!-- <el-option v-if="targetLangList.length === 0" :disabled="true" :label="$t('newProjectV2.firstSelSourceLangTip')" value="0"></el-option> -->
                <el-option v-for="(item, index) in domainList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.transDomainName : $domainCase[item.transDomainCode] ? $domainCase[item.transDomainCode] : item.transDomainName"
                  :value="item.transDomainCode">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 工作流程 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.workFlow')" prop="projectProcessType">
              <el-select v-model="form.projectProcessType" :placeholder="$t('newProjectV2.workFlowTip')"
                @change="form.isSyncTransReview = 0">
                <el-option v-for="(item, index) in projectFlow" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <!-- 译审同步 -->
              <div class="isSyncTransReview-box" v-show="form.projectProcessType !== '1'">
                <span>{{ $t('newProjectV2.isSyncTransReview') }}</span>
                <el-switch v-model="form.isSyncTransReview" active-color="#13ce66" :active-value="1" :inactive-value="0">
                </el-switch>
              </div>
            </el-form-item>
          </div>
          <!-- 截至时间 -->
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.limitTime')" prop="deliveryTime">
              <el-date-picker type="datetime" :placeholder="$t('newProjectV2.dateTip')" :editable="false"
                :clearable="false" v-model="form.deliveryTime" :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"></el-date-picker>
            </el-form-item>
          </div>
        </div>
        <!-- 译审同步 -->
        <!-- <div class="row" v-if="form.projectProcessType !== '1'">
          <div class="cell">
            <el-form-item :label="$t('newProjectV2.isSyncTransReview')">
              <el-switch v-model="form.isSyncTransReview" active-color="#13ce66" :active-value="1" :inactive-value="0">
              </el-switch>
            </el-form-item>
          </div>
        </div> -->
        <!-- 备注 -->
        <div class="row">
          <el-form-item class="remark" :label="$t('newProjectV2.remark')">
            <el-input show-word-limit resize="none" maxlength="70" type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </div>
        <div class="btn">
          <!-- 取消 -->
          <el-button class="cancel" @click="handleCancel">{{ $t('newProjectV2.cancel') }}</el-button>
          <!-- 下一步 -->
          <el-button type="primary" @click="nextStep" class="next">{{ $t('newProjectV2.nextStep') }}
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- 创建自定义领域 -->
    <create-custom-domain :dialogVisible="createDomainVisible" @handleClose="handleCreateDomainClose"
      @handleConfirm="handleCreateDomainConfirm">
    </create-custom-domain>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import CreateCustomDomain from '@/components/create-custom-domain';

import {
  getFileLang,
  getUploadSign,
  queryLangList,
  queryTransDomain,
  queryDefaultTransDomain
} from '@/services/newProjectApi';

export default {
  name: 'NewItem',
  components: {
    CreateCustomDomain
  },
  data() {
    const checkLimitTime = (rule, value, callback) => {
      if (this.form.deliveryTime === '') {
        return callback(new Error(this.$t('newProjectV2.dateTip')))
      }
      else if (new Date(new Date(this.form.deliveryTime).setMinutes(new Date(this.form.deliveryTime).getMinutes() + 1)) < new Date()) {
        return callback(new Error(this.$t('projectV2.limitTimeErrorText')))
      } else {
        callback();
      }
    }

    const checkDomain = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('newProjectV2.domainTip')))
      }
      if (this.$refs.domainCodeSelect.createdSelected && this.CUSTOM_DOMAIN) {
        this.form.domainCode = this.form.domainCode.trim();
        if (value.length < 1 || value.length > 10) {
          return callback(new Error(this.$t('common.customDomainLength')));
        }
      }
      callback();
    }

    // 当前时间的往后七天
    // const time = new Date();
    // const timeFormate = moment(time.setTime(time.getTime() + 3600 * 1000 * 24 * 7)).format('YYYY-MM-DD HH:mm:ss');
    const time = moment().add(7, 'd').format('YYYY-MM-DD HH:mm:ss');

    return {
      CUSTOM_DOMAIN: CUSTOM_DOMAIN,
      host: '',
      fileList: [],
      acceptStr: this.$supportFileSuffixes().acceptStr,  // 支持文件格式
      formData: new FormData(),
      filePathList: [],
      form: {
        name: '',                       // 项目名称
        sourceLang: '',                 // 源语言编码
        targetLang: '',                 // 目标语言编码
        domainCode: '',                 // 领域
        projectProcessType: '1',        // 项目流程
        deliveryTime: time,             // 结束时间
        isSyncTransReview: 0, //译审同步
        remark: '',                     // 备注
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 86400000;
        },
      },
      sourceLangList: [],
      targetLangList: [],
      domainList: [],
      projectFlow: [{
        value: "1",
        label: this.$t('newProjectV2.translation')
      }, {
        value: "2",
        label: this.$t('newProjectV2.transProofread')
      }, {
        value: "3",
        label: this.$t('newProjectV2.transProofreadReview')
      }],
      rules: {
        name: [
          { required: true, message: this.$t('newProjectV2.projectNameTip'), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('newProjectV2.projectNameLength'), trigger: 'blur' }
        ],
        domainCode: [
          // { required: true, message: this.$t('newProjectV2.domainTip'), trigger: 'change' },
          { required: true, validator: checkDomain, trigger: 'change' },
        ],
        sourceLang: [
          { required: true, message: this.$t('newProjectV2.sourceLangTip'), trigger: 'change' }
        ],
        targetLang: [
          { required: true, message: this.$t('newProjectV2.targetLangTip'), trigger: 'change' }
        ],
        projectProcessType: [
          { required: true, message: this.$t('newProjectV2.workFlowTip'), trigger: 'change' }
        ],
        deliveryTime: [
          { validator: checkLimitTime, trigger: 'change', required: true }
        ]
      },
      notGetLong: true,
      notChangeLang: true,
      createDomainVisible: false,
      domainCodeCopy: "", //dimaincode拷贝的值
      isShowTooltip: false, //展示气泡
    };
  },
  mounted() {
    this.getSourceLangList()
    this.getQueryDefaultTransDomain()
  },
  watch: {

  },
  methods: {
    onMouseOver(str) { // 内容超出，显示文字提示内容
      const tag = this.$refs[`str${str}`]
      const parentWidth = tag[0].parentNode.offsetWidth // 获取元素父级可视宽度
      const contentWidth = tag[0].offsetWidth // 获取元素可视宽度
      this.isShowTooltip = contentWidth < parentWidth
      // console.log(contentWidth <= parentWidth,'@@@',contentWidth,parentWidth);
    },
    async getQueryDefaultTransDomain() {
      const { success, result } = await queryDefaultTransDomain({})
      if (success) {
        this.domainList = result
      }
    },

    handleCreateDomainClose() {
      this.createDomainVisible = false
      this.form.domainCode = this.form.domainCode === 'add_domain' ? '' : this.form.domainCode
    },

    async handleCreateDomainConfirm(data) {
      if (this.form.sourceLang) {
        await this.getDomainList(this.form.sourceLang, this.form.targetLang)
      } else {
        await this.getQueryDefaultTransDomain()
      }
      if (!this.form.domainCode) {
        this.domainList.forEach(item => {
          if (item.transDomainName === data.domain) {
            this.form.domainCode = item.transDomainCode
          }
        })
      }
      this.createDomainVisible = false
    },
    //领域change事件
    changedomainCode(value) {
      if (value === 'add_domain') {
        this.createDomainVisible = true
        this.form.domainCode = this.domainCodeCopy
        return
      }
      this.domainCodeCopy = value;
    },
    handleCancel() {
      this.$router.push({
        name: 'ProjectList'
      });
    },
    // 下一步
    nextStep() {
      let self = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$message.closeAll();
          if (this.fileList.length >= 1) {
            // 获取源语言中文名
            let sourceName = self.sourceLangList.find(i => {
              return self.form.sourceLang === i.sourceLang;
            }).sourceLangName;

            // 获取目标语言中文名
            let targetName = self.targetLangList.find(i => {
              return self.form.targetLang === i.targetLang;
            }).targetLangName;

            // 文件列表
            let arr = [];
            self.fileList.forEach(item => {
              arr.push({
                name: item.name,
                filePath: item.path,
                fileSuffix: /([^\/\\]+)\.([a-z]+)$/i.exec(item.name)[2]
              });
            });

            // 获取领域中文名
            // let domainName = '';
            // const isCreatedSelected = this.$refs.domainCodeSelect.createdSelected
            // if (isCreatedSelected && this.CUSTOM_DOMAIN) {
            //   domainName = this.form.domainCode;
            //   // this.form.domainCode = '';
            // } else {
            //   }
            let domainName = self.domainList.find(i => self.form.domainCode === i.transDomainCode).transDomainName;
            if (this.form.projectProcessType == 1) {
              this.form.isSyncTransReview = 0
            }
            this.$router.push({
              name: 'ProjectSetting',
              query: {
                key: this.$Base64.encode(
                  JSON.stringify({
                    ...self.form,
                    langDesc: sourceName + '>' + targetName,
                    fileList: arr,
                    domainName,
                    // isCreatedSelected
                  })
                )
              }
            });
          } else {
            this.$message.warning(this.$t('newProjectV2.firstUploadFileTip'));
          }
        }
      });
    },
    async sourceLangChange() {
      let self = this;
      if (this.notGetLong) {
        this.notChangeLang = false;
      }
      self.$message.closeAll();
      let { result, success } = await queryLangList({
        type: 2,
        sourceLang: self.form.sourceLang
      });

      if (!success) { return; }

      // this.targetLangList = result
      self.targetLangList = result.filter(item => {
        return item.status === 1
      });

      if (self.targetLangList.length === 0) {
        self.$message.warning(this.$t('newProjectV2.langNotSupport'));
        self.form.sourceLang = '';
        return;
      }
      let tarItem = null
      this.targetLangList.forEach((item, index) => {
        if (item.targetLang == 'zh') {
          tarItem = item
          this.targetLangList.splice(index, 1)
        }
      })
      tarItem && this.targetLangList.unshift(tarItem)
      // 目标语言默认选择第一项
      self.form.targetLang = self.targetLangList[0].targetLang;

      self.getDomainList(self.form.sourceLang, self.form.targetLang);
    },
    async getDomainList(sourceLangCode, targetLangCode) {
      let self = this;
      let { result, success } = await queryTransDomain({
        sourceLangCode,
        targetLangCode
      })
      if (!success) { return; }
      self.domainList = result;
      // let map = new Map()
      // for (const item of [...result, ...self.domainList]) {
      //   map.set(item.transDomainCode, item)
      // }
      // self.domainList = [...map.values()]
      // 领域默认选择第一项
      if ((!this.form.domainCode) || !(this.domainList.map(item => item.transDomainCode).includes(this.form.domainCode))) {
        self.form.domainCode = result[0].transDomainCode;
        this.domainCodeCopy = result[0].transDomainCode;
      }
    },
    async getSourceLangList() {
      let { result, success } = await queryLangList({
        type: 1
      });
      if (!success) { return; }
      this.sourceLangList = result;
    },
    uploadSectionFile(param) {
      let self = this;
      if (param.file.obp) {
        return;
      }
      // 获得上传签名
      getUploadSign().then(({ result }) => {
        // 上传地址
        this.host = result.host;

        let re = /([^\/\\]+)\.([a-z]+)$/i;
        let resultArr = re.exec(param.file.name);
        // 文件类型
        let type = resultArr[2].toLocaleLowerCase();

        // self.fileList.forEach(item => {
        //   if (item.uid === param.file.uid) {
        //     item.type = type;
        //     item.imgSrc = require(`./assets/images/${type}.png`);
        //   }
        // });

        let para = {
          ...result,
          key: `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        this.getFileHost(param);
      });
    },
    getFileHost(param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };

      axios.post(FileController, self.formData, config).then((resp) => {
        let { result } = resp.data;

        // 检测语言
        // self.getLong(result.fileName, param);

        self.filePathList.push(result);

        self.fileList.forEach(item => {
          // 上传文件夹的param和单个上传的param不一样
          if (item.uid === param.file.uid) {
            item.path = result.fileName;
          }
        });

        // 项目名称默认获得第一个文件的名称
        let re = /([^\/\\]+)\.([a-z]+)$/i;
        let resultArr = re.exec(self.fileList[0].name);
        self.form.name = resultArr[1].substring(0, 50);

        // 检测语言
        if (['png', 'jpg', 'tiff', 'bmp'].includes(result.fileName.split('.')[result.fileName.split('.').length - 1])) {
          return;
        } else {
          self.getLong(result.fileName, param);
        }
      });
    },
    // 检测语言方法
    getLong(path, param) {
      let self = this;
      getFileLang({
        path
      }).then(({ result, success }) => {
        if (!success) {
          return;
        }
        // 添加源语言字段
        this.fileList.forEach(item => {
          if (item.uid === param.file.uid) {
            item.source = result.sourceLangName || "";
          }
        });

        // 如果文件源语言检测为空，则跳过
        if (!result.sourceLang) {
          return;
        }

        // 只允许首次改变源语言
        if (self.notGetLong && self.notChangeLang) {
          if (!this.sourceLangList.some(item => item.sourceLang === result.sourceLang)) {
            return;
          }
          self.notGetLong = false;
          self.form.sourceLang = result.sourceLang;
          self.sourceLangChange();
        }
      });
    },
    handleDelete(index) {
      this.fileList.splice(index, 1);
      if (this.fileList.length === 0) {
        this.notGetLong = true;
      }
    },
    handleExceed() {
      this.$message.closeAll();
      this.$message.warning(this.$t('newProjectV2.maxFileNum', [10]));
    },
    uploadChange(file) {
      this.fileList.push({
        ...file,
        source: '',
        path: '',
        obp: false,
        imgSrc: ''
      });
    },
    beforeUploadFile(file) {
      console.log(file);
      let re = /([^\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      console.log(resultArr, '@@@');
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > this.$supportFileSuffixes().maxSize;

      let typeFlag = this.$supportFileSuffixes(type).isSupport;
      let isFileNameLength = file.name.length > 160
      this.$message.closeAll();
      if (!typeFlag) {
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$supportFileSuffixes().tip]));
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.warning(this.$t('newProjectV2.notSupportEmptyFile'));
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }

      this.fileList.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.$message.warning(this.$t('newProjectV2.uploadFileRepeat'));
          this.fileList.pop();
          file.obp = true;
          return false;
        }
      });

      if (isLt20M) {
        this.$message.warning(this.$t('newProjectV2.maxUploadFileSize', [this.$supportFileSuffixes().maxSize]));
        file.obp = true;
        this.fileList.pop();
        return false;
      }
      if (isFileNameLength) {
        this.$message.warning(this.$t('newProjectV2.fileNameLength'))
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }
      return true;
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>